export const ActiveCampaignIcon = () => {
  return (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 0h24c2.211 0 4 1.789 4 4v24c0 2.211-1.789 4-4 4H4c-2.211 0-4-1.789-4-4V4c0-2.211 1.789-4 4-4z"
        fill="#356AE6"
      />
      <path
        d="M16.311 16.744c.289 0 .578-.11.889-.344.367-.256.689-.467.689-.467l.111-.078-.111-.077c-.045-.034-4.878-3.39-5.378-3.711-.233-.167-.5-.2-.711-.1-.2.1-.311.31-.311.566v1.145l.044.022c.034.022 3.356 2.333 4 2.767.267.189.523.277.778.277z"
        fill="#fff"
      />
      <path
        d="M22.789 14.733c-.289-.21-10.656-7.444-11.1-7.755l-.145-.1v1.778c0 .566.3.777.667 1.044 0 0 7.956 5.545 8.944 6.222-.988.69-8.477 5.878-8.955 6.178-.567.378-.622.622-.622 1.133v1.912s10.966-7.845 11.2-8.023c.5-.378.61-.822.622-1.144v-.2c.011-.4-.2-.756-.611-1.045z"
        fill="#fff"
      />
    </svg>
  );
};
